import { ReactNode } from 'react';
import Col from 'antd/lib/col';
import Typography from 'antd/lib/typography';
import { EMPTY_VALUE, billLabelStyle, billValueStyle } from '../billStyles';

const { Text } = Typography;

// A half-width, read-only label + value cell shared by the source-data sections (site info, vendor).
// Falls back to the em-dash placeholder for empty values.
export const BillReadOnlyField = ({ label, value }: { label: string; value: ReactNode }) => (
    <Col span={12}>
        <Text style={billLabelStyle}>{label}</Text>
        <Text style={billValueStyle}>{value || EMPTY_VALUE}</Text>
    </Col>
);
